(ns motorsaif.utils
  (:refer-clojure :exclude [format random-uuid])
  #?(:cljs
     (:import
      (goog.i18n NumberFormat)
      (goog.i18n.NumberFormat Format)))
  (:require
   [clojure.string :as str]
   #?@(:clj [[clj-time.coerce :as time-coerce]
             [hickory.convert :as hc]
             [hickory.core :as hickory]
             [hickory.select :as hs]
             [clojure.java.io :as io]
             [clj-time.core :as time-core]
             [clj-time.format :as time-format]
             [muuntaja.core]]
       :cljs [[cljs-time.coerce :as time-coerce]
              [cljs-time.core :as time-core]
              [goog.events.EventType :as event-type]
              [goog.events :as events]
              [cljs-time.format :as time-format]
              [goog.dom.ViewportSizeMonitor]
              [goog.string]]))
  #?(:cljs (:require-macros
            [motorsaif.utils])))

(defmacro locals->map
  "Creates a map from symbols in the current lexical scope.
  Each symbol passed becomes a keyword key in the map,
  and its value in the current scope becomes the map value.
  Example: (let [a 1 b 2] (locals->map a b)) => {:a 1 :b 2}"
  [& symbols]
  (let [key-val-forms (mapcat (fn [s] [(keyword s) s]) symbols)]
    ;; Construct the code that will build the map at runtime
    ;; `(hash-map :key1 symbol1 :key2 symbol2 ...)
    `(hash-map ~@key-val-forms)))

(defmacro ?>
  "Conditionally execute function if exists"
  [afn]
  `(when (fn? ~afn)
     (~afn)))

(defn official-account? [business]
  (= (:db/id business) 17592186055972))

;; (granular-now-date :month)
;; (granular-now-date :week)
;; (granular-now-date :day)




(defn regex-escape-str
  "Escape a character if it is an element of `escape-chars`."
  [s]
  (let [escape-chars #{\\ \^ \$ \* \+ \? \. \| \( \) \{ \} \[ \]}]
    (str/join (map (fn [c]
                     (str (when (contains? escape-chars c) "\\") c)) s))))




;; #?(:cljs
;;    (defn ease-loop
;;      ([target-n duration callback-fn]
;;       (ease-loop callback-fn (map #(js/Math.easeOutCubic (* 16 %) 0 target-n duration) (range 0 (/ duration 17)))))
;;      ([callback-fn ease-vals]
;;       (js/requestAnimationFrame
;;        (fn []
;;          (when (first ease-vals)
;;            (callback-fn (js/Math.round (first ease-vals)))
;;            (ease-loop callback-fn (next ease-vals))))))))

;; (-> (slurp
;;                        (io/resource
;;                         (str "public/img/svg/logo2.svg")))
;;                       (str/replace "viewBox" "view-box")
;;                       (str/replace "linearGradient" "linear-gradient")
;;                       (str/replace "gradientUnits" "gradient-units")
;;                      )


#?(:cljs
   (do
     (defn cond-css [& items]
       (->> (reduce (fn [acc [pred klass]]
                      (if pred
                        (conj acc klass)
                        acc))
                    []
                    (partition 2 items))
            (str/join " ")))

     (defn set-root-property [k val]
       (.setProperty (.-documentElement.style js/document) (str "--" (name k)) val))

     (let [*events (atom {})]
       (defn register-event
         ""
         [id target events afn]
         (let [events (if (vector? events)
                        events
                        [events])]
           (doseq [[idx event] (map-indexed vector events)
                   :let [path [id idx]
                         ?ev (get-in @*events path)]]
             (when ?ev
               (events/unlistenByKey ?ev))
             (swap! *events assoc-in path (events/listen target event afn)))
           (map-indexed vector events))))


     ;; (def is-pwa? (.-matches (js/window.matchMedia "(display-mode: standalone)")))
     (def is-pwa?
       (if (and (exists? js/window) (exists? js/window.matchMedia))
         (.-matches (js/window.matchMedia "(display-mode: standalone)"))
         false))

     ;; (def is-desktop? (> (.-width js/window.visualViewport) 900))
     (def is-desktop?
       (if (and (exists? js/window) (exists? js/window.visualViewport))
         (> (.-width js/window.visualViewport) 900)
         false))
     (def is-ios? (some? (re-find #"iPhone|iPad" (or js/navigator.userAgent " "))))
     (def is-android? (some? (re-find #"Android" (or js/navigator.userAgent " "))))
     (defonce *click-events (atom {}))
     (defn on-click-outside-element
       "Fire event one time when anything that is outside element-id is clicked. Returns function to remove event.
  Overlay z-index is 1000, so position item on top."
       [{:keys [element-id
                remove-on-click?
                add-overlay?
                on-outside-click]
         :or {remove-on-click? true}}]
       (let [get-element (fn [] (.getElementById js/document element-id))]
         (when-let [existing-event (get @*click-events element-id)]
           (events/unlistenByKey existing-event))

         (when add-overlay?
           (.add (.-classList js/document.body) "show-overlay"))

         (let [click-fn (fn [e]
                          (let [wanted-element (get-element)
                                ?notification (.getElementById js/document "notification")]
                            (when-not ?notification
                              (when wanted-element
                                (let [outside-wanted-element? (not (.contains wanted-element
                                                                              (.-target e)))]
                                  (when outside-wanted-element?
                                    (when add-overlay?
                                      (.remove (.-classList js/document.body) "show-overlay"))
                                    (when remove-on-click?
                                      (events/unlistenByKey (get @*click-events element-id)))
                                    (.stopPropagation e)
                                    (.preventDefault e)
                                    (on-outside-click)))))))

               event-action (if is-ios? #_(re-find #"iPhone|iPad" (.-userAgent js/navigator))
                                event-type/TOUCHEND
                                event-type/CLICK)
               event (events/listen js/document.body event-action click-fn)]

           (swap! *click-events assoc element-id event)
           (fn [& [opts]]
             (when (and add-overlay?
                        (not (:keep-overlay opts)))
               (.remove (.-classList js/document.body) "show-overlay"))
             (events/unlistenByKey (get @*click-events element-id))))))))

(defn request-type->str [request-type]
  (condp = request-type
    :repair "Repair"
    :part "Part"
    :upgrade "Upgrade"))

(defn owner-handle [owner]
  (or
   (:business/name owner)
   (:user/handle owner)))

(defn truncate-string-with-ellipsis [s length]
  (let [total-length (count s)]
    (if (> total-length length)
      (str (subs s 0 length) "...")
      s)))

(defn filter-reqs [preds reqs]
  (let [{:keys [make model year type]} preds
        {:keys [min max]} year
        make-path [:request/object :car/make]
        model-path [:request/object :car/model]
        year-path [:request/object :car/year]
        preds (-> []
                  (cond-> make (conj #(= (get-in % make-path) make))
                          model (conj #(= (get-in % model-path) model))
                          min (conj #(>= (get-in % year-path) min))
                          max (conj #(<= (get-in % year-path) max))))]
    (filter (apply every-pred preds) reqs)))
